<div *ngIf="event | async; let events" [ngStyle]="{'text-align':'center'}">
	<div *ngIf="artists | async; let artist">
		<div *ngIf="programs | async; let program">
			<h3 *ngIf="showYesButton">Do you really want to duplicate this event?</h3> 
			<h3 *ngIf="!showYesButton">Duplication in progress...</h3>
			<button mat-button (click)="showYesButton=false;duplicateEvent(events,artist,program)" cdkFocusInitial *ngIf="showYesButton">YES</button>	
			<button mat-button (click)="onNoClick()" *ngIf="showYesButton">NO</button>		
		</div>
	</div>	
</div>